import type { Loadable } from "@/shared/lib/loadable";
import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { BaseHeaderWrapper } from "@/shared/ui/base-header-wrapper";
import { ValueWithLabel } from "@/widgets/value-with-label";
import type { FreightMatching } from "@x-mile/api-contract";
import type { PreviewDeliveryProposalOfferCargo } from "../../../model";

export const CompanyForm = ({
  companies,
  previewValues,
}: {
  companies: Loadable<FreightMatching.schemas.Company[]>;
  previewValues: PreviewDeliveryProposalOfferCargo;
}) => {
  const selectedCompany =
    companies.status === "success"
      ? companies.data.find((company) => company.id === previewValues.companyId)
      : null;

  if (!selectedCompany) {
    return null;
  }

  return (
    <BaseHeaderWrapper title="運送会社情報" maxWidth="628px">
      <BaseKeyValue keyLabel="運送会社">
        <ValueWithLabel label="企業名" value={selectedCompany.name} emphasis />
      </BaseKeyValue>
    </BaseHeaderWrapper>
  );
};
